(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initDaleHeaderMenu();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeDaleMenu();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    closeDaleMenu() {
      if (!this.daleMenuItems) return;
      this.daleMenuItems.forEach((item) => {
        item.classList.remove('is-open');
        item.querySelectorAll('.dale-header-menu__toggle, button.dale-header-menu__trigger').forEach((control) => {
          control.setAttribute('aria-expanded', 'false');
        });
      });
    }

    initDaleHeaderMenu() {
      const menu = this.querySelector('.dale-header-menu');
      if (!menu || menu.dataset.menuReady === 'true') return;

      menu.dataset.menuReady = 'true';
      this.daleMenuItems = menu.querySelectorAll('.dale-header-menu__item');

      this.daleMenuItems.forEach((item) => {
        const controls = item.querySelectorAll('.dale-header-menu__toggle, button.dale-header-menu__trigger');
        if (!controls.length) return;

        controls.forEach((control) => {
          control.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            this.closeDaleMenu();
            if (!isOpen) {
              item.classList.add('is-open');
              controls.forEach((menuControl) => menuControl.setAttribute('aria-expanded', 'true'));
            }
          });
        });

        item.addEventListener('mouseenter', () => {
          if (window.innerWidth <= 989) return;
          this.closeDaleMenu();
          item.classList.add('is-open');
          controls.forEach((control) => control.setAttribute('aria-expanded', 'true'));
        });

        item.addEventListener('mouseleave', () => {
          if (window.innerWidth <= 989) return;
          item.classList.remove('is-open');
          controls.forEach((control) => control.setAttribute('aria-expanded', 'false'));
        });
      });

      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) this.closeDaleMenu();
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeDaleMenu();
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
